'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crudStore = exports.preferSuper = exports.inlineEditorHost = exports.destroyable = exports.inlineEditor = exports.field = exports.editor = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _symbol = require('babel-runtime/core-js/symbol');

var _symbol2 = _interopRequireDefault(_symbol);

var _mobx = require('mobx');

var _validx = require('validx');

var _ConfirmDialogState = require('../components/ConfirmDialog/ConfirmDialogState');

var _ConfirmDialogState2 = _interopRequireDefault(_ConfirmDialogState);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _forEach = require('lodash/forEach');

var _forEach2 = _interopRequireDefault(_forEach);

var _uniqueId = require('lodash/uniqueId');

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
} /**
   * This module is for easily making simple model editors
   * with strong conventions and plenty of hooks for customization.
   */


/**
 * IMPORTANT!!!!!!!
 * The ordering of decorators matter! See `src/stores/ui/BenefitsScreenStore` for example usage.
 */

/**
 * Symbol for privatizing the fields discovered when
 * decorating properties.
 * @type {[type]}
 */
var FIELDS = (0, _symbol2.default)('FIELDS');

/**
 * Inherits the decorated viewmodel class and adds common editor functionality
 * to it. It also prescribes a constructor that takes a `Model` instance
 * as the first argument, or null/undefined when editing a new model.
 *
 * The `field` decorator is used to mark a field for mapping to/from a model.
 *
 * The decorated class must implement the following interface:
 * - save(mapped: Object) => Promise<Boolean>
 */
var editor = exports.editor = function editor() {
  return function (target) {
    var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;

    var _fields = target.prototype[FIELDS] || [];

    /**
     * A class that inherits the class being decorated. This
     * means that the returned class is the actual class being
     * used, and therefore decides when to call into the decorated class.
     */
    return _class = function (_target) {
      (0, _inherits3.default)(Editor, _target);

      /**
       *
       * @param  {Model|object} model
       * If not specified, generates a unique ID and marks it as new.
       */
      function Editor(model) {
        var _ref;

        (0, _classCallCheck3.default)(this, Editor);

        for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).call.apply(_ref, [this, model].concat(rest)));

        _initDefineProp(_this, 'disabled', _descriptor, _this);

        _initDefineProp(_this, 'editing', _descriptor2, _this);

        _initDefineProp(_this, 'validation', _descriptor3, _this);

        if (!model) {
          _this.isNew = true;
          _this.id = (0, _uniqueId2.default)();
        } else {
          _this.isNew = false;
          _this.model = model;
          _this.id = model.id;
        }
        return _this;
      }

      /**
       * If not editing an existing model, maps fields from the
       * model onto the viewmodel - the fields to map are those
       * which have the `field` decorator.
       *
       * To override what gets mapped, implement `mapFromModel(mapped: Object) => Object`
       *
       * @chainable
       */


      (0, _createClass3.default)(Editor, [{
        key: 'startEditing',
        value: function startEditing() {
          this.editing = true;
          if (this.isNew) return this;

          var mapped = (0, _pick2.default)(this.model, _fields);
          if (this.mapFromModel) {
            mapped = this.mapFromModel(mapped);
          }

          this.set(mapped);
          if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'startEditing', this)) {
            (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'startEditing', this).apply(this, arguments);
          }
          return this;
        }

        /**
         * Cancels editing by setting the `editing` to false and resetting validation state.
         */

      }, {
        key: 'cancelEditing',
        value: function cancelEditing() {
          this.editing = false;
          this.validation.reset();
          if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'cancelEditing', this)) {
            return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'cancelEditing', this).call(this);
          }
        }

        /**
         * Validates the object (calls the `validate()` method if it exists),
         * maps fields from the viewmodel into an object, passing them along
         * to `save(mapped: Object) => Promise<any>` on the decorated class.
         *
         * If the `save` method returns an explicit `false`, it is implied that saving did not succeed.
         * Of course, it it throws an exception that's not good either.
         *
         * To override what gets mapped, implement `mapToModel(mapped: Object) => Object`.
         * The return value is passed to `save`. Note that is does not actually mutate the model.
         *
         * `save` *must* be implemented! The resolved promise determines if
         * saving happened or not. If it did, stops editing.
         *
         * @return {Promise<Boolean>}
         */

      }, {
        key: 'save',
        value: function () {
          var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
            var _this2 = this;

            var mapped, result;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    (0, _assert2.default)((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'save', this), target.name + ' must implement a \'save\' method');

                    _context.next = 3;
                    return this.validate();

                  case 3:
                    if (this.validation.isValid) {
                      _context.next = 5;
                      break;
                    }

                    return _context.abrupt('return', false);

                  case 5:
                    mapped = (0, _pick2.default)(this, _fields);


                    if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'mapToModel', this)) {
                      mapped = (0, _mobx.runInAction)('editor.mapToModel', function () {
                        return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'mapToModel', _this2).call(_this2, mapped);
                      });
                    }

                    this.set({ disabled: true });
                    _context.prev = 8;
                    _context.next = 11;
                    return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'save', this).call(this, mapped);

                  case 11:
                    result = _context.sent;

                    if (!(result !== false)) {
                      _context.next = 15;
                      break;
                    }

                    this.set({ editing: false });
                    return _context.abrupt('return', true);

                  case 15:
                    return _context.abrupt('return', false);

                  case 16:
                    _context.prev = 16;

                    this.set({ disabled: false });
                    return _context.finish(16);

                  case 19:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, this, [[8,, 16, 19]]);
          }));

          function save() {
            return _ref2.apply(this, arguments);
          }

          return save;
        }()

        /**
         * Shortcut for shallow-assigning an object's properties to this instance.
         *
         * @param {Object} obj
         * @chainable
         */

      }, {
        key: 'set',
        value: function set(obj) {
          (0, _assign2.default)(this, obj);
          return this;
        }

        /**
         * Validates `validationRules` if they exist on the instance, and calls `validate`
         * on the decorated class (if it exists).
         *
         * In order to register validation errors, the `validate` method must mutate the `validation` context.
         *
         * @return {Promise}
         */

      }, {
        key: 'validate',
        value: function () {
          var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
            return _regenerator2.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    if (this.validationRules) {
                      this.validation.reset().validate(this, this.validationRules);
                    }

                    if (!(0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'validate', this)) {
                      _context2.next = 4;
                      break;
                    }

                    _context2.next = 4;
                    return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'validate', this).call(this);

                  case 4:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function validate() {
            return _ref3.apply(this, arguments);
          }

          return validate;
        }()

        /**
         * Calls `destroy` on the decorated class while safely maintaining `disabled` state.
         *
         * @return {Promise}
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
            return _regenerator2.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    (0, _assert2.default)((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'destroy', this), 'attempted to call \'destroy\' on ' + target.name + ' but it does not implement it.');

                    this.set({ disabled: true });
                    _context3.prev = 2;
                    _context3.next = 5;
                    return (0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'destroy', this).call(this);

                  case 5:
                    return _context3.abrupt('return', _context3.sent);

                  case 6:
                    _context3.prev = 6;

                    this.set({ disabled: false });
                    return _context3.finish(6);

                  case 9:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, this, [[2,, 6, 9]]);
          }));

          function destroy() {
            return _ref4.apply(this, arguments);
          }

          return destroy;
        }()

        /**
         * Clears the fields. If the decorated class implements and returns
         * `false`, will do nothing.
         *
         * @chainable
         */

      }, {
        key: 'clear',
        value: function clear() {
          var _this3 = this;

          if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'clear', this)) {
            if ((0, _get3.default)(Editor.prototype.__proto__ || (0, _getPrototypeOf2.default)(Editor.prototype), 'clear', this).call(this) === false) {
              return;
            }
          }

          (0, _mobx.runInAction)(function () {
            (0, _forEach2.default)(_fields, function (field) {
              _this3[field] = null;
            });
          });

          return this;
        }
      }]);
      return Editor;
    }(target), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'disabled', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return false;
      }
    }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'editing', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return false;
      }
    }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'validation', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return (0, _validx.validationContext)();
      }
    }), _applyDecoratedDescriptor(_class.prototype, 'startEditing', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'startEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'cancelEditing', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'cancelEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'set', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'set'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validate', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validate'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clear', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clear'), _class.prototype)), _class;
  };
};

/**
 * Property decorator for fields that `editor` should use for its magical mapping.
 */
var field = exports.field = function field(target, name, descriptor) {
  target[FIELDS] = target[FIELDS] || [];
  target[FIELDS].push(name);
  return (0, _mobx.observable)(target, name, descriptor);
};

/**
 * Derives the decorated class and adds functionality for use with a
 * store decorated with `inlineEditorHost`. Makes the class implement all
 * the things needed for `editor`, passing the calls to the store that owns
 * the instance.
 */
var inlineEditor = exports.inlineEditor = function inlineEditor() {
  return function (target) {
    return function (_target2) {
      (0, _inherits3.default)(InlineEditor, _target2);

      /**
       *
       * @param  {Model|object} model
       * The model to manage, or nothing if a new instance.
       *
       * @param  {Object} opts.parentStore
       * A reference to the parent store, used to for callbacks.
       */
      function InlineEditor(model, opts) {
        (0, _classCallCheck3.default)(this, InlineEditor);

        var _this4 = (0, _possibleConstructorReturn3.default)(this, (InlineEditor.__proto__ || (0, _getPrototypeOf2.default)(InlineEditor)).apply(this, arguments));

        _this4.options = opts;
        (0, _assert2.default)(opts, 'inline editor constructed without options - it needs an options object with a parentStore');
        (0, _assert2.default)(opts.parentStore, 'inline editor constructed without options.parentStore');
        if (!model) {
          _this4.startEditing();
        }
        return _this4;
      }

      /**
       * Marshals the saving to the parent store.
       */


      (0, _createClass3.default)(InlineEditor, [{
        key: 'save',
        value: function save() {
          var _options$parentStore;

          return (_options$parentStore = this.options.parentStore).saveItem.apply(_options$parentStore, [this].concat(Array.prototype.slice.call(arguments)));
        }

        /**
         * Calls `cancelEditing` on the editor, and calls the parent store
         * so it can do additional stuff (like removing new instances).
         */

      }, {
        key: 'cancelEditing',
        value: function cancelEditing() {
          var _options$parentStore2;

          if ((0, _get3.default)(InlineEditor.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditor.prototype), 'cancelEditing', this)) {
            (0, _get3.default)(InlineEditor.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditor.prototype), 'cancelEditing', this).apply(this, arguments);
          }

          (_options$parentStore2 = this.options.parentStore).cancelEditing.apply(_options$parentStore2, [this].concat(Array.prototype.slice.call(arguments)));
        }

        /**
         * If the parent store supports it, calls `destroy`.
         * While not required, destroying stuff is common.
         *
         * This should only be called for existing models, not new ones that
         * have not been saved yet.
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
            return _regenerator2.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    if (!this.options.parentStore.destroy) {
                      _context4.next = 2;
                      break;
                    }

                    return _context4.abrupt('return', this.options.parentStore.destroy(this));

                  case 2:
                  case 'end':
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          function destroy() {
            return _ref5.apply(this, arguments);
          }

          return destroy;
        }()
      }]);
      return InlineEditor;
    }(target);
  };
};

/**
 * Marks a viewmodel as destroyable, giving it a `ConfirmDialogState`
 * as `confirmDestruction` that is shown before calling `destroy` on the
 * decorated class.
 */
var destroyable = exports.destroyable = function destroyable() {
  return function (target) {
    return function (_target3) {
      (0, _inherits3.default)(Destroyable, _target3);

      /**
       * Adds a `confirmDestruction` field for use with the corresponding React component.
       */
      function Destroyable() {
        (0, _classCallCheck3.default)(this, Destroyable);

        var _this5 = (0, _possibleConstructorReturn3.default)(this, (Destroyable.__proto__ || (0, _getPrototypeOf2.default)(Destroyable)).apply(this, arguments));

        _this5.confirmDestruction = new _ConfirmDialogState2.default();
        return _this5;
      }

      /**
       * Waits for confirmation before calling the decorated class' `destroy` method.
       * @return {Promise}
       */


      (0, _createClass3.default)(Destroyable, [{
        key: 'destroy',
        value: function () {
          var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    (0, _assert2.default)((0, _get3.default)(Destroyable.prototype.__proto__ || (0, _getPrototypeOf2.default)(Destroyable.prototype), 'destroy', this), target.name + ' needs to implement \'destroy\'.');
                    _context5.next = 3;
                    return this.confirmDestruction.show();

                  case 3:
                    if (_context5.sent) {
                      _context5.next = 5;
                      break;
                    }

                    return _context5.abrupt('return');

                  case 5:
                    if (!(0, _get3.default)(Destroyable.prototype.__proto__ || (0, _getPrototypeOf2.default)(Destroyable.prototype), 'destroy', this)) {
                      _context5.next = 7;
                      break;
                    }

                    return _context5.abrupt('return', (0, _get3.default)(Destroyable.prototype.__proto__ || (0, _getPrototypeOf2.default)(Destroyable.prototype), 'destroy', this).call(this));

                  case 7:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));

          function destroy() {
            return _ref6.apply(this, arguments);
          }

          return destroy;
        }()
      }]);
      return Destroyable;
    }(target);
  };
};

/**
 * Derives a store, giving it functionality to act as an inline editor host
 * with a lot of boilerplate taken care of:
 * - Managing existing and new items
 * - Transforming models to viewmodels
 * - calling create or update based on new/existing state
 * - start/stop editing
 * - destroying models (when implemented)
 *
 * The decorated class must implement:
 * - ViewModel: ViewModelClass | () => ViewModelClass
 * - getItems() => Model[]
 * - create(data: Object) => Promise<Boolean>
 * - update(id: any, data: Object) => Promise<Boolean>
 *
 * Optional:
 * - destroy(item: ViewModel) => Promise
 */
var inlineEditorHost = exports.inlineEditorHost = function inlineEditorHost() {
  return function (target) {
    var _desc2, _value2, _class3, _descriptor4;

    return _class3 = function (_target4) {
      (0, _inherits3.default)(InlineEditorHost, _target4);

      function InlineEditorHost() {
        var _ref7;

        var _temp, _this6, _ret;

        (0, _classCallCheck3.default)(this, InlineEditorHost);

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return _ret = (_temp = (_this6 = (0, _possibleConstructorReturn3.default)(this, (_ref7 = InlineEditorHost.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost)).call.apply(_ref7, [this].concat(args))), _this6), _this6.transformer = (0, _mobx.createTransformer)(_this6.createViewModel.bind(_this6)), _initDefineProp(_this6, 'newItems', _descriptor4, _this6), _temp), (0, _possibleConstructorReturn3.default)(_this6, _ret);
      }
      /**
       * MobX magic used to map models to viewmodels reactively.
       */


      /**
       * Tracks new items
       * @type {ObservableArray}
       */


      (0, _createClass3.default)(InlineEditorHost, [{
        key: 'newItem',


        /**
         * Creates a new instance of `ViewModel` with no model.
         *
         * @return {ViewModel}
         */
        value: function newItem() {
          var vm = this.createViewModel();
          this.newItems.unshift(vm);
          return vm;
        }

        /**
         * Invokes `ViewModel` with the given model and
         * the options for the `inlineEditor` constructor.
         *
         * @param  {Model?} model
         * @return {ViewModel}
         */

      }, {
        key: 'createViewModel',
        value: function createViewModel(model) {
          var _this7 = this;

          var ViewModel = this.ViewModel;
          // ViewModels set internal state upon creation,
          // so we allow that here.
          return _mobx.extras.allowStateChanges(true, function () {
            return new ViewModel(model, {
              parentStore: _this7
            });
          });
        }

        /**
         * Callback from the `inlineEditor`, calls `create` or `update`.
         *
         * @param  {ViewModel} item
         * @param  {Object} props
         * @return {Promise<Boolean>}
         */

      }, {
        key: 'saveItem',
        value: function () {
          var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(item, props) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    if (!item.isNew) {
                      _context6.next = 8;
                      break;
                    }

                    _context6.next = 3;
                    return this.create(props);

                  case 3:
                    _context6.t0 = _context6.sent;

                    if (!(_context6.t0 === false)) {
                      _context6.next = 6;
                      break;
                    }

                    return _context6.abrupt('return', false);

                  case 6:

                    this.newItems.remove(item);
                    return _context6.abrupt('return', true);

                  case 8:
                    _context6.next = 10;
                    return this.update(item.id, props);

                  case 10:
                    _context6.t1 = _context6.sent;

                    if (!(_context6.t1 === false)) {
                      _context6.next = 13;
                      break;
                    }

                    return _context6.abrupt('return', false);

                  case 13:
                    return _context6.abrupt('return', true);

                  case 14:
                  case 'end':
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));

          function saveItem(_x, _x2) {
            return _ref8.apply(this, arguments);
          }

          return saveItem;
        }()

        /**
         * Called from the `inlineEditor`, calls `cancelEditing` on the decorated class
         * if it exists. If that call returns an explicit false, will not remove the viewmodel
         * from the `newItems` array.
         *
         * @param  {ViewModel} item
         * @return {Promise}
         */

      }, {
        key: 'cancelEditing',
        value: function () {
          var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(item) {
            var result;
            return _regenerator2.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    if (!(0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'cancelEditing', this)) {
                      _context7.next = 6;
                      break;
                    }

                    _context7.next = 3;
                    return (0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'cancelEditing', this).call(this, item);

                  case 3:
                    result = _context7.sent;

                    if (!(result === false)) {
                      _context7.next = 6;
                      break;
                    }

                    return _context7.abrupt('return');

                  case 6:

                    this.newItems.remove(item);

                  case 7:
                  case 'end':
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));

          function cancelEditing(_x3) {
            return _ref9.apply(this, arguments);
          }

          return cancelEditing;
        }()

        /**
         * Called by the `inlineEditor`, calls `destroy` if it exists on
         * the decorated class.
         *
         * @param  {ViewModel} item
         * @return {Promise}
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(item) {
            return _regenerator2.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    if (!(0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'destroy', this)) {
                      _context8.next = 6;
                      break;
                    }

                    _context8.next = 3;
                    return (0, _get3.default)(InlineEditorHost.prototype.__proto__ || (0, _getPrototypeOf2.default)(InlineEditorHost.prototype), 'destroy', this).call(this, item);

                  case 3:
                    _context8.t0 = _context8.sent;

                    if (!(_context8.t0 === false)) {
                      _context8.next = 6;
                      break;
                    }

                    return _context8.abrupt('return');

                  case 6:

                    // Just in case..
                    this.newItems.remove(item);

                  case 7:
                  case 'end':
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));

          function destroy(_x4) {
            return _ref10.apply(this, arguments);
          }

          return destroy;
        }()
      }, {
        key: 'items',


        /**
         * Combines new items with items from
         * @return {[type]} [description]
         */
        get: function get() {
          return [].concat((0, _toConsumableArray3.default)(this.newItems.slice()), (0, _toConsumableArray3.default)(this.getItems().map(this.transformer)));
        }
      }]);
      return InlineEditorHost;
    }(target), (_descriptor4 = _applyDecoratedDescriptor(_class3.prototype, 'newItems', [_mobx.observable], {
      enumerable: true,
      initializer: function initializer() {
        return [];
      }
    }), _applyDecoratedDescriptor(_class3.prototype, 'items', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'items'), _class3.prototype)), _class3;
  };
};

/**
 * Utility decorator used to call the super method if it exists.
 */
var preferSuper = exports.preferSuper = function preferSuper(target, name, descriptor) {
  var oldValue = descriptor.value;
  var proto = (0, _getPrototypeOf2.default)(target);
  descriptor.value = function patched() {
    if (proto[name]) {
      return proto[name].apply(proto, arguments);
    }

    return oldValue.apply(this, arguments);
  };
};

/**
 * A very conventional CRUD store. Stack this on below
 *   @inlineEditorHost()
 *
 * Set `modelStore` to an instance of a store with the following methods:
 * - create(data: Object) => Promise
 * - update(id: any, data: Object) => Promise
 * - destroy update(id: any) => Promise
 */
var crudStore = exports.crudStore = function crudStore(opts) {
  return function (target) {
    var _desc3, _value3, _class5;

    opts = (0, _extends3.default)({
      itemsProp: 'items'
    }, opts);

    return _class5 = function (_target5) {
      (0, _inherits3.default)(CrudStore, _target5);

      function CrudStore() {
        (0, _classCallCheck3.default)(this, CrudStore);
        return (0, _possibleConstructorReturn3.default)(this, (CrudStore.__proto__ || (0, _getPrototypeOf2.default)(CrudStore)).apply(this, arguments));
      }

      (0, _createClass3.default)(CrudStore, [{
        key: 'getItems',
        value: function getItems() {
          this._assertModelStore();
          var items = this.modelStore[opts.itemsProp];
          (0, _assert2.default)(items, 'Model store\'s "' + opts.itemsProp + '" returned nothing useful');
          return items;
        }

        /**
         * Delegates the create call to the model store.
         */

      }, {
        key: 'create',
        value: function create(data) {
          this._assertModelStore();
          return this.modelStore.create(data);
        }

        /**
         * Delegates the update call to the model store.
         */

      }, {
        key: 'update',
        value: function update(id, data) {
          this._assertModelStore();
          return this.modelStore.update(id, data);
        }

        /**
         * Delegates the destroy call to the model store, except it
         * will pass it the model instead of the viewmodel.
         */

      }, {
        key: 'destroy',
        value: function () {
          var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(vm) {
            var result;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    this._assertModelStore();
                    _context9.next = 3;
                    return this.modelStore.destroy(vm.model);

                  case 3:
                    result = _context9.sent;
                    return _context9.abrupt('return', result);

                  case 5:
                  case 'end':
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          }));

          function destroy(_x5) {
            return _ref11.apply(this, arguments);
          }

          return destroy;
        }()

        /**
         * Asserts that we have a model store before attempting to invoke anything on it.
         */

      }, {
        key: '_assertModelStore',
        value: function _assertModelStore() {
          (0, _assert2.default)(this.modelStore, 'modelStore has not been set on this instance of a crudStore.');
        }
      }]);
      return CrudStore;
    }(target), (_applyDecoratedDescriptor(_class5.prototype, 'getItems', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'getItems'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'create', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'create'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'update', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'update'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'destroy', [preferSuper], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'destroy'), _class5.prototype)), _class5;
  };
};
//# sourceMappingURL=editor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/data/editor.js
// module id = 628
// module chunks = 0